import './News.css'

//images
import safepork_img from './photos/safepork_conf.jpeg'
import biosecurity_img from './photos/biosecurity_conf.JPG'

//Components
import DiscoverMore from "../../Controller/Buttons/DiscoverMore";
import NewsItem from './NewsItem';


const News = () => {
    return (
        <div className='section'>
            <h1 id='title'> News </h1>
            <div className='news-page'>
                <div className='news-div'>
                    <div className='recent-news'>
                        <div className='recent-news'>
                            <h1> Upcoming Events </h1>
                            <div className='newsletter' id='recent-newsletter'>
                                <div className='recent-news-desc'>
                                    <div className='news_item'>
                                        <h2
                                            onMouseEnter={(e) => {
                                                e.target.style.textDecoration = 'underline'
                                                e.target.style.cursor = 'pointer'
                                            }}
                                            onMouseLeave={(e) => { e.target.style.textDecoration = 'initial' }}
                                            onClick={() => { window.open("https://ucanr.edu/blogs/blogcore/postdetail.cfm?postnum=51754") }}>
                                            Stay tuned for future species-specific webinars on swine and small ruminants this Fall! </h2>
                                    </div>
                                    <div className='news_item'>
                                        <h2
                                            onMouseEnter={(e) => {
                                                e.target.style.textDecoration = 'underline'
                                                e.target.style.cursor = 'pointer'
                                            }}
                                            onMouseLeave={(e) => { e.target.style.textDecoration = 'initial' }}
                                            onClick={() => { window.open("https://ucanr.edu/blogs/blogcore/postdetail.cfm?postnum=51754") }}>
                                            On-farm visits for developing customized biosecurity plans have now ended, but stay tuned for their return in 2023! If you are interested, please contact:  </h2>
                                        <ul className='contact-list'>
                                            <li>Alda Pires at <a href="mailto:apires@ucdavis.edu">apires@ucdavis.edu</a> if you are based in California</li>
                                            <li>Ragan Adams at <a href="mailto:ragan.Adams@colostate.edu">ragan.Adams@colostate.edu</a> if you are based in Colorado</li>
                                            <li>Craig McConnel at <a href="mailto:mcconnel@wsu.edu">cmcconnel@wsu.edu</a> if you are based in Washington</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='news-div'>

                    <div className='past-news'>
                        <h1> Past Events </h1>
                        <div className='newsletter'>
                            <NewsItem title='New webinar: Healthy Animals &amp; Healthy People in Agritourism, coordinated by UC ARN SAREP Agritourism Program' />
                        </div>
                        <div className='newsletter'>
                            <NewsItem
                                title='Dr. Alda Pires presented a talk on Genomic sequencing of STEC isolates from feral pigs and
                                outdoor-raised pigs in high-risk contact areas in California at the 2023 SAFEPORK Conference
                                (New Orleans, LA)'
                                img={safepork_img}
                            />
                        </div>
                        <div className='newsletter'>
                            <NewsItem title='Dr. Alda Pires participated in the UC ANR Statewide Conference, where she shared updates on the FARM PPE project and her other project on Crop-Livestock Integration and Food Safety Risks and Improving Biosecurity of Small-scale and Backyard farmers' />
                        </div>
                        <div className='newsletter'>
                            <NewsItem
                                url='https://wae23.mapyourshow.com/8_0/sessions/session-details.cfm?scheduleid=142'
                                title='Dr. Alda Pires presented a talk on Biosecurity and Disease Prevention at the 2023 World Ag Expo
                                in Tulare, CA, as part of the seminar "Focus on Management Practices and Tools for
                                Antimicrobial Stewardship"'
                            />
                        </div>
                        <div className='newsletter'>
                            <NewsItem
                                title='Dr. Alda Pires presented a poster on the FARM PPE project titled "Improving biosecurity of small-scale and backyard farmers in the US" at the 2023 Conference of Research Workers in Animal
                                Diseases conference (2023 CRWAD, Chicago, IL)'
                                img={biosecurity_img}
                            />
                        </div>
                        <DiscoverMore name="More Info" url="/training" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default News;